import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillStatus } from '@types'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'

const bill0 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-OPEN-0',
    payable: true,
    status: BillStatus.Open,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill1 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-WAITING_PAYMENT-1',
    status: BillStatus.WaitingPayment,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill2 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-CLOSED-2',
    status: BillStatus.Closed,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill3 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-OVERDUE-3',
    status: BillStatus.Overdue,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill4 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-PAID-4',
    status: BillStatus.Paid,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill5 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZED-5',
    status: BillStatus.Snoozed,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill6 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-OPEN-with-debit-6',
    status: BillStatus.Open,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      has_debit: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill7 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-WAITING_PAYMENT-with-debit-7',
    status: BillStatus.WaitingPayment,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      has_debit: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill8 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-CLOSED-with-debit-8',
    status: BillStatus.Closed,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      has_debit: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill9 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-OVERDUE-with-debit-9',
    status: BillStatus.Overdue,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      has_debit: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill10 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-PAID-with-debit-10',
    status: BillStatus.Paid,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      has_debit: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill11 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZED-with-debit-11',
    status: BillStatus.Snoozed,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      has_debit: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)

export const billListAllStatusMock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'bill-OPEN-0',
  bills: [
    bill0,
    bill1,
    bill2,
    bill3,
    bill4,
    bill5,
    bill6,
    bill7,
    bill8,
    bill9,
    bill10,
    bill11,
  ],
})
